import { ItemCardWithPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCardWithPieces/ItemCardWithPieces";
import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import { ItemNoAndTypeWithPTagsOrdered } from "@coworker/apprestructured/src/task-management/types/TaskDetailTypes";
import { FixaQuantityStepper } from "@coworker/apprestructured/src/shared/wrappers/FixaQuantityStepper/FixaQuantityStepper";
import { Loading } from "../../../loading";
import React from "react";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";

interface ArticlesPrintPtagsQuantityContentProps {
  itemsWithPieces: ItemWithPieces[];
  itemNosAndTypeWithOrderedDetails:
    | ItemNoAndTypeWithPTagsOrdered[]
    | null
    | Loading;
  onPrintPtagsQuantityChange: (
    itemNo: string,
    newPrintPtagsQuantity: number
  ) => void;
}

export const ArticlesPrintPtagsQuantityContent = ({
  itemsWithPieces,
  itemNosAndTypeWithOrderedDetails,
  onPrintPtagsQuantityChange,
}: ArticlesPrintPtagsQuantityContentProps) => {
  const pTagsByItemNo = new Map(
    Array.isArray(itemNosAndTypeWithOrderedDetails)
      ? itemNosAndTypeWithOrderedDetails.map(
          ({ no, pieces, ptags_ordered }) => [no, { pieces, ptags_ordered }]
        )
      : []
  );

  return (
    <>
      {itemsWithPieces.map((item) => (
        <React.Fragment key={item.no}>
          <ItemCardWithPieces item={item} />
          <FixaQuantityStepper
            small
            fluid
            defaultValue={pTagsByItemNo.get(item.no)?.ptags_ordered ?? 0}
            ariaDescribedById={`item-print-ptags-quantity-stepper-${item.no}`}
            ariaDescribedBy={`print-ptags-quantity-stepper-${item.no}`}
            minVal={1}
            maxVal={pTagsByItemNo.get(item.no)?.pieces ?? 0}
            onQuantityChange={(newQuantity) =>
              onPrintPtagsQuantityChange(item.no, Number(newQuantity))
            }
          />
          <div>
            <FixaText tagName="p" textStyle="Body.M">
              No Ptags needed
            </FixaText>
            <FixaCheckbox
              onChange={() => onPrintPtagsQuantityChange(item.no, 0)}
              value={item.no}
              id={`item-print-ptags-checkbox-${item.no}`}
            />
          </div>
        </React.Fragment>
      ))}
    </>
  );
};
